/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activefrom1Inputs */

const vi_activefrom1 = /** @type {(inputs: Activefrom1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoạt động từ`)
};

/**

* @param {Activefrom1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const activefrom1 = /** @type {((inputs?: Activefrom1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activefrom1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_activefrom1(inputs)
});
export { activefrom1 as "activeFrom" }